export const toCamelCase = (text: string): string => {
	const camelCase = text
		.replace(/(?:_\w)/gu, (m) => m[1].toUpperCase())
		.replace(/(?:^\w|[A-Z]|\b\w)/gu, (leftTrim, index) => (index === 0 ? leftTrim.toLowerCase() : leftTrim.toUpperCase()))
		.replace(/\s+/gu, '');

	// console.log(`toCamelCase: ${text} -> ${camelCase}`);
	return camelCase;
};
